// extracted by mini-css-extract-plugin
export default {"main":"CuestionarioNoDisponible_main__GAhyv","image":"CuestionarioNoDisponible_image__2TsXt","info":"CuestionarioNoDisponible_info__MZeEy"};